import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';

export default function ContactsPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28">
        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1200px' }}>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-8 text-center">
              Контакты
            </h1>
            <p className="text-sm md:text-base text-foreground-600 text-center max-w-xl mx-auto mb-12">
              Позвоните или напишите — обсудим вашу задачу и&nbsp;подготовим расчёт
            </p>

            <div className="flex flex-col lg:flex-row gap-10 lg:gap-12 items-start">
              <div className="flex-1 w-full">
                <div className="bg-background-100 border border-background-200/60 rounded-lg p-7 md:p-9">
                  <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-5">Свяжитесь с нами</h2>

                  <a href="tel:+79174131562" className="flex items-center gap-3 text-2xl font-bold text-foreground-950 hover:text-primary-500 transition-colors mb-4">
                    <span className="w-8 h-8 flex items-center justify-center text-primary-500">
                      <i className="ri-phone-fill text-2xl"></i>
                    </span>
                    +7 917 413-15-62
                  </a>

                  <div className="flex items-center gap-3 text-sm text-foreground-600 mb-6">
                    <span className="w-8 h-8 flex items-center justify-center">
                      <i className="ri-time-line text-xl text-primary-500"></i>
                    </span>
                    Ежедневно, 9:00–18:00
                  </div>

                  <div className="border-t border-background-200 pt-5 mt-2">
                    <p className="text-sm text-foreground-600 mb-4">Выберите удобный способ связи:</p>
                    <div className="flex flex-wrap items-center gap-3">
                      <a href="https://wa.me/79174131562" target="_blank" rel="noopener noreferrer" className="whitespace-nowrap flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 cursor-pointer">
                        <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-line text-lg"></i></span> WhatsApp
                      </a>
                      <a href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0" target="_blank" rel="noopener noreferrer" className="whitespace-nowrap flex items-center gap-2 bg-accent-600 hover:bg-accent-700 text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 cursor-pointer">
                        <span className="w-5 h-5 flex items-center justify-center"><i className="ri-chat-3-line text-lg"></i></span> MAX
                      </a>
                      <a href="https://t.me/Gmgmg0202" target="_blank" rel="noopener noreferrer" className="whitespace-nowrap flex items-center gap-2 bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 cursor-pointer">
                        <span className="w-5 h-5 flex items-center justify-center"><i className="ri-telegram-line text-lg"></i></span> Telegram
                      </a>
                      <a href="tel:+79174131562" className="whitespace-nowrap flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm px-5 py-3 rounded-md transition-all duration-300 cursor-pointer">
                        <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-lg"></i></span> Позвонить
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1 w-full">
                <div className="rounded-lg overflow-hidden border border-background-200/60">
                  <iframe src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=220225922174" width="100%" height="400" style={{ border: 0 }} title="Яндекс Карта"></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}